import { axios } from '../../../../services/axios';
import * as CONST from '../../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.CLIENT_INTERCOM_NOTIFICATION_CREATE_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.CLIENT_INTERCOM_NOTIFICATION_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const clientIntercomNotificationCreate = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.CLIENT_INTERCOM_NOTIFICATION_CREATE_REQUEST });

    axios.post('/clients/send-intercom-notificaton', data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
